export function clearState (state) {
  state.user = []
  sessionStorage.clear()
}



// WEBPACK FOOTER //
// ./src/Vuex/mutation.js